import script from "./object_colsConnector.vue?vue&type=script&setup=true&lang=js"
export * from "./object_colsConnector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__